import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { LeadsDataServiceProvider } from '@services/lead/leads.data.service';
import { ExportLeadsJobsResponse } from '@models/models';
import { SettingsProvider } from '@services/settings/settings';

@Component({
	selector: 'export-leads-modal',
	template: require('./export-leads-modal.html')
})
export class ExportLeadsModalComponent implements OnInit, OnDestroy {
	private exportLeadsModalRef: NgbModalRef;
	private unsubscribe = new Subject();

	statusDescription: string;
	exportAvailable: boolean;

	constructor(
		private leadsDataServiceProvider: LeadsDataServiceProvider,
		private modalService: SNModalService,
		private messageService: MessageService,
		private settingsService: SettingsProvider
	) {}

	ngOnInit(): void {
		this.getPaymentExportState();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	exportLeads(content): void {
		this.leadsDataServiceProvider
			.getLeadsExport()
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(data: ExportLeadsJobsResponse) => {
					if (data.exportState === 'EXPORTING_HAS_BEEN_STARTED') {
						this.statusDescription =
							'Preparing to start your export! This may take up to an hour.';
						this.openModal(content);
					} else if (data.exportState === 'EXPORTING_IN_PROGRESS') {
						this.statusDescription = `Exporting in progress (${
							data.percentageComplete
						}% complete)...`;
						this.openModal(content);
					} else if (data.exportState === 'EXPORTING_IN_QUEUE') {
						this.statusDescription =
							"We're moving heaven and earth to make sure your export is next.";
						this.openModal(content);
					}
				},
				error => {
					const { errorTitle, errorMessage } = error.error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
				}
			);
	}

	private openModal(content) {
		this.exportLeadsModalRef = this.modalService.openModal(content, {
			windowClass: 'ng-bootstrap-modal__small leads-jobs-width'
		});
	}

	private getPaymentExportState(): void {
		this.settingsService.timeFormatSettings
			.pipe(
				takeUntil(this.unsubscribe),
				filter((data): boolean => !!data),
				map((data): boolean => data.leadExportAvailable)
			)
			.subscribe(
				(exportState: boolean): boolean => (this.exportAvailable = exportState)
			);
	}

	onDismiss(): void {
		this.exportLeadsModalRef.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/leads/modals/export-leads-modal/export-leads-modal.ts